document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.recipes-carousel-section');

  sections.forEach(function (section) {
    const slider = section.querySelector('.recipes-carousel__slider');
    const prevBtn = section.querySelector('.recipes-carousel__nav-btn--prev');
    const nextBtn = section.querySelector('.recipes-carousel__nav-btn--next');

    if (!slider || typeof Swiper === 'undefined') return;

    const swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 600,
      grabCursor: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
        },
        990: {
          spaceBetween: 24,
        },
      },
    });
  });
});
